import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useScreenerUnread } from '../../context/ScreenerUnreadContext.tsx';

const PATH_TO_CODE: Record<string, string> = {
  '/screener/momentum-ai':          'MOMENTUM_AI',
  '/screener/postive-gap-up':       'POSITIVE_GAP_UP',
  '/screener/breakout-ai':          'BREAKOUT_AI',
  '/screener/ipo-based-bullish':    'IPO_BASED_BULL_RUN',
  '/screener/vcp':                  'VCP',
  '/screener/bullish-flag-pennant': 'BULLISH_FLAG_PENNANT',
  '/screener/narrow-range':         'NARROW_RANGE',
  '/screener/mountain-scoop':       'MOUNTAIN_SCOOP',
};

const ScreenerSeenTracker: React.FC = () => {
  const location = useLocation();
  const { markSeen, markAnnouncementsSeen } = useScreenerUnread();

  useEffect(() => {
    if (location.pathname === '/updates') {
      markAnnouncementsSeen();
      return;
    }
    const code = PATH_TO_CODE[location.pathname];
    if (code) markSeen(code);
  }, [location.pathname, markSeen, markAnnouncementsSeen]);

  return null;
};

export default ScreenerSeenTracker;
